<template>
  <div>
    <apexchart
      type="bar"
      :options="chartOptions"
      :series="chartDataSeries"
      />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'WeekpartColumnChart',
  props: [
    'chartData'
  ],

  data() {
    return {
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          },
          type: 'bar',
          id: 'Footfall 1',
        },
        theme: {
          palette: this.$store.state.userPrefsStore.themeID
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        stroke: {
          colors: ['transparent'],
          width: 40
        },
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true
        },
        xaxis: {
          labels: {
            show: false
          }
        }
      },
    }
  },
  computed: {
    chartDataSeries() {
      let series = [
        {
          name: 'Weekday',
          data: [{
            x: 'Weekday',
            y: 0
          }],
        },
        {
          name: 'Weekend',
          data: [{
            x: 'Weekend',
            y: 0
          }],
        },
      ]

      if (this.chartData) {
        this.chartData.forEach((e) => {
          const currentDay = parseInt(moment(e._time).format('d'))

          if (currentDay == 0 || currentDay == 6) {
            series[1].data[0].y += e.count
          } else {
            series[0].data[0].y += e.count
          }
        });
      }

      return series
    }
  }
}
</script>
